import React from "react";
import RequestItem from "./request-item";
import { formatToPeso } from "../../../util/helperFunctions";

function RequestDetailItem({ prDetail, setPreviewImage }) {
  const getAttachmentUrl = (attachment, filePath) => {
    console.log("Attachment:", attachment);
    console.log("File Path:", filePath);

    const resourcesUrl = process.env.REACT_APP_ATTACHMENT_DATA_RESOURCES_URL;

    // OSS Upload
    if (filePath && filePath.startsWith("http")) {
      return filePath;
    }

    // Legacy Upload
    return `${resourcesUrl}/${attachment}`;
  };

  const renderDynamicAttachmentsFiles = (
    file_type,
    attachment,
    file_path,
    index,
  ) => {
    const attachmentUrl = getAttachmentUrl(attachment, file_path);
    const isImageAttachment = file_type?.includes("image");
    const isPdfAttachment = attachmentUrl?.toLowerCase().endsWith(".pdf");
    const isPreviewableAttachment = isImageAttachment || isPdfAttachment;

    console.log("Final URL:", attachmentUrl);

    if (isImageAttachment) {
      return (
        <div className="attachment-item" key={index}>
          <img
            src={attachmentUrl}
            alt=""
            className="clickable-image"
            onClick={() => setPreviewImage(attachmentUrl)}
          />
        </div>
      );
    }

    return (
      <div className="attachment-item" key={index}>
        <a
          href={attachmentUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            if (isPreviewableAttachment) {
              e.preventDefault();
              setPreviewImage(attachmentUrl);
            }
          }}
        >
          <i
            className={`fa ${isPdfAttachment ? "fa-file-pdf-o" : "fa-file-o"} fa-4x`}
            aria-hidden="true"
          ></i>
        </a>
      </div>
    );
  };

  return (
    <div className="request-detail-row request-detail--item">
      <RequestItem
        fieldName={"Description"}
        fieldValue={prDetail?.description}
      />
      <RequestItem fieldName={"Remarks"} fieldValue={prDetail?.remarks} />
      <RequestItem fieldName={"Quantity"} fieldValue={prDetail?.quantity} />
      <RequestItem
        fieldName={"Estimated Price"}
        fieldValue={formatToPeso(prDetail?.estimated_price)}
      />
      <RequestItem
        fieldName={"Estimated Cost"}
        fieldValue={formatToPeso(prDetail?.estimated_cost)}
      />

      <div className="request-item">
        <span>Attachments</span>

        <div className="request-item-attachment-container">
          {prDetail?.purchases_attachment_detail?.length > 0 ? (
            prDetail.purchases_attachment_detail.map((prAttachment, index) => {
              console.log("Attachment Object:", prAttachment);

              return renderDynamicAttachmentsFiles(
                prAttachment.file_type,
                prAttachment.attachment,
                prAttachment.file_path,
                index,
              );
            })
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <div className="request-item">
        <span>Files</span>

        <div className="request-item-attachment-container">
          {prDetail?.purchases_files_detail?.length > 0 ? (
            prDetail.purchases_files_detail.map((prAttachment, index) => {
              console.log("File Object:", prAttachment);

              return renderDynamicAttachmentsFiles(
                prAttachment.file_type,
                prAttachment.attachment,
                prAttachment.file_path,
                index,
              );
            })
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RequestDetailItem;
